import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

export const reports = accountId => ({
  parentNav: 'reports',
  routes: [
    'account_overview_reports',
    'conversation_reports',
    'csat_reports',
    'nps_reports',
    'bot_reports',
    'ai_reports',
    'agent_reports',
    'label_reports',
    'inbox_reports',
    'team_reports',
    'sla_reports',
    'custom_reports',
    'goals_index',
  ],
  menuItems: [
    {
      icon: 'arrow-trending-lines',
      label: 'REPORTS_OVERVIEW',
      key: 'reports_overview',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/overview`),
      toStateName: 'account_overview_reports',
    },
    {
      icon: 'chat',
      label: 'REPORTS_CONVERSATION',
      key: 'conversation_reports',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/conversation`),
      toStateName: 'conversation_reports',
    },
    {
      icon: 'emoji',
      label: 'CSAT',
      key: 'csat',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/csat`),
      toStateName: 'csat_reports',
    },
    {
      icon: 'poll-outline',
      label: 'NPS',
      key: 'nps',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/nps`),
      toStateName: 'nps_reports',
    },
    {
      icon: 'bot',
      label: 'REPORTS_BOT',
      key: 'bot_reports',
      hasSubMenu: false,
      featureFlag: FEATURE_FLAGS.AGENT_BOTS,
      toState: frontendURL(`accounts/${accountId}/reports/bot`),
      toStateName: 'bot_reports',
    },
    {
      icon: 'bot',
      label: 'REPORTS_AI',
      key: 'ai_reports',
      hasSubMenu: false,
      featureFlag: FEATURE_FLAGS.AGENT_BOTS,
      toState: frontendURL(`accounts/${accountId}/reports/ai`),
      toStateName: 'ai_reports',
    },
    {
      icon: 'people',
      label: 'REPORTS_AGENT',
      key: 'agent_reports',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/agent`),
      toStateName: 'agent_reports',
    },
    {
      icon: 'tag',
      label: 'REPORTS_LABEL',
      key: 'label_reports',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/label`),
      toStateName: 'label_reports',
    },
    {
      icon: 'mail-inbox-all',
      label: 'REPORTS_INBOX',
      key: 'inbox_reports',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/inboxes`),
      toStateName: 'inbox_reports',
    },
    {
      icon: 'people-team',
      label: 'REPORTS_TEAM',
      key: 'team_reports',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/teams`),
      toStateName: 'team_reports',
    },
    {
      icon: 'document-list-clock',
      label: 'REPORTS_SLA',
      key: 'sla_reports',
      hasSubMenu: false,
      featureFlag: FEATURE_FLAGS.SLA,
      toState: frontendURL(`accounts/${accountId}/reports/sla`),
      toStateName: 'sla_reports',
    },
    {
      icon: 'bar-chart-outline',
      label: 'CUSTOM_REPORTS.TITLE',
      key: 'custom_reports',
      hasSubMenu: false,
      featureFlag: FEATURE_FLAGS.CUSTOM_REPORTS,
      toState: frontendURL(`accounts/${accountId}/reports/custom`),
      toStateName: 'custom_reports',
      badge: 'BETA',
    },
    {
      icon: 'checkmark-circle-outline',
      label: 'GOALS.TITLE',
      key: 'goals',
      hasSubMenu: false,
      featureFlag: FEATURE_FLAGS.CUSTOM_REPORTS,
      toState: frontendURL(`accounts/${accountId}/reports/goals`),
      toStateName: 'goals_index',
    },
  ],
});

export default reports;
